import axios from "axios";
import { clearStorage } from "./storage";

// Set up a global Axios response interceptor.
// On a 401 Unauthorized response, clears local storage and fires a
// custom window event that SessionWatcher (inside the React tree) will
// catch in order to redirect to /login via React Router.
export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    // Pass successful responses straight through
    (response) => response,

    // Handle error responses
    (error) => {
      const status = error?.response?.status;

      if (status === 401) {
        // Clear all stored auth data
        clearStorage();

        // Dispatch a custom event so the SessionWatcher component
        // (which lives inside <BrowserRouter>) can do a clean React-Router
        // navigation instead of a hard window.location reload.
        window.dispatchEvent(new CustomEvent("session-expired"));
      }

      return Promise.reject(error);
    }
  );
}
